"use strict";

exports.__esModule = true;
exports.ConditionGroup = void 0;
var _core = require("@blueprintjs/core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _SortableRows = require("../../Core/SortableRows");
var _constants = require("../constants");
var _styles = require("../styles");
var _Condition = require("../Condition");
var _ConditionContent = require("./ConditionContent");
var _vimanaTypes = require("@vimana/vimana-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ConditionGroup = exports.ConditionGroup = function ConditionGroup(_ref) {
  var condition = _ref.condition,
    errorMessage = _ref.errorMessage,
    classifyName = _ref.classifyName,
    noLogicExpression = _ref.noLogicExpression,
    updateSelf = _ref.updateSelf,
    _ref$isTypeDataItemOn = _ref.isTypeDataItemOnly,
    isTypeDataItemOnly = _ref$isTypeDataItemOn === void 0 ? false : _ref$isTypeDataItemOn;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _useState = (0, _react.useState)(false),
    isPopupOpened = _useState[0],
    setIsPopupOpened = _useState[1];
  classifyName = classifyName + "-Group";
  var setCondition = function setCondition(data) {
    updateSelf(data);
  };
  var updateCondition = function updateCondition(newCondition, index) {
    return function (self) {
      condition.conditions[index] = self;
      setCondition(condition);
    };
  };
  var addGroupToCondition = function addGroupToCondition() {
    condition.conditions.push({
      conditionType: "GROUP_TYPE",
      conditions: [],
      isOpen: true
    });
    setCondition(condition);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement(_styles.ClassifyAddButtonsContainer, null, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    isOpen: isPopupOpened,
    interactionKind: _core.PopoverInteractionKind.CLICK,
    position: _core.Position.BOTTOM,
    enforceFocus: true,
    content: !isTypeDataItemOnly && /*#__PURE__*/_react["default"].createElement(_Condition.ConditionTypePopup, {
      conditions: condition.conditions,
      setConditionArray: function setConditionArray(data) {
        condition.conditions = data;
        setCondition(condition);
      },
      onClose: function onClose() {
        return setIsPopupOpened(!isPopupOpened);
      }
    })
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "EnrichEditorUI.ConditionGroup.AddCondition",
    icon: "plus",
    intent: _core.Intent.PRIMARY,
    onClick: function onClick() {
      if (isTypeDataItemOnly) {
        condition.conditions.push({
          conditionType: _constants.ConditionTypes[2].key
        });
        setCondition(condition);
      } else {
        setIsPopupOpened(!isPopupOpened);
      }
    }
  }, translate("EnrichEditorUI.ConditionGroup.AddCondition", "Add condition"))), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "EnrichEditorUI.ConditionGroup.AddGroup",
    icon: "plus",
    intent: _core.Intent.PRIMARY,
    onClick: addGroupToCondition,
    style: {
      marginLeft: "5px"
    }
  }, translate("EnrichEditorUI.ConditionGroup.AddCompound", "Add compound")))), !(0, _utils.validateConditionsNumber)(condition.conditions) ? /*#__PURE__*/_react["default"].createElement(_styles.Row, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "rgb(194, 48, 48)"
    }
  }, errorMessage)) : null, /*#__PURE__*/_react["default"].createElement(_SortableRows.AccordionSortableRows, {
    items: condition.conditions,
    renderItem: function renderItem() {
      return null;
    },
    getKey: function getKey(_v, i) {
      return classifyName + "-Condition-" + i;
    },
    renderSubRow: function renderSubRow(condition, index) {
      return /*#__PURE__*/_react["default"].createElement(_ConditionContent.ConditionContent, {
        condition: condition,
        first: index === 0 || noLogicExpression,
        updateSelf: updateCondition(condition, index),
        isTypeDataItemOnly: isTypeDataItemOnly
      });
    },
    getHeader: function getHeader(condition, index) {
      return /*#__PURE__*/_react["default"].createElement(_Condition.Condition, {
        condition: condition,
        first: index === 0 || noLogicExpression,
        updateSelf: updateCondition(condition, index)
      });
    },
    setItems: function setItems(conditions) {
      condition.conditions = conditions;
      setCondition(condition);
    },
    toggleItem: function toggleItem(newCondition, i) {
      condition.conditions[i] = Object.assign({}, newCondition, {
        isOpen: !newCondition.isOpen
      });
      setCondition(condition);
    },
    isOpen: function isOpen(condition) {
      return condition.isOpen;
    }
  }));
};